'use strict';

import $ from 'jquery';
import slick from 'slick-carousel';

/**
 * Init Slider elements
 */
export default class Slider {

    constructor() {
        this.sliderClassName = '.slider--hero';

        this.settings = {
            dots: true,
            infinite: true,
            speed: 500,
            fade: true,
            cssEase: 'linear',
            slidesToScroll: 1,
            arrows: true,
            centerMode: false,
            slidesToShow: 1,
            variableWidth: false,
            mobileFirst: true,
            lazyLoad: 'progressive',
            autoplay: true,
            autoplaySpeed: 5000,
        };
    }

    init(options) {
        let self = this;
        self.addInteractions();
    } // end init: method

    addInteractions() {
        let self = this;

        $(self.sliderClassName).each(function () {
            self.initSlider(self, $(this));
        });
    } // end addInteractions: method

    /**
     * Init slider
     *
     * @param self
     * @param slider
     */
    initSlider(self, slider) {

        var controlsContainer = self.getControlsContainer(slider);

        self.settings.appendArrows = controlsContainer;

        if (slider.data('dots')) {
            self.settings.dots = true;
            self.settings.appendDots = controlsContainer;
        }
        slider.slick(self.settings);
    }

    /**
     * Return container (slider itself or slider-overlay--container) to add slider controls
     *
     * @returns {*}
     */
    getControlsContainer(slider) {
        var controlsContainer = slider.parent().find('.slider-overlay--container');

        if (controlsContainer.length == 0) {
            // no slider overlay exists append arrows / dots to slider element
            controlsContainer = slider;
        } else {
            // slider overlay exists append arrows / dots to slider overlay
            controlsContainer.first();
        }
        return controlsContainer;
    }

}
